import { UseInfiniteQueryResult } from 'react-query'

type EntityWithUuid = {
  uuid: string | undefined
}

export type CrunchesPageEntities =
  | EntityWithUuid[]
  | UseInfiniteQueryResult<{
      data: EntityWithUuid[]
      count: number
    }>

type ShouldInvalidateCrunchesPage = (
  page: CrunchesPageEntities,
  entityUuid: string
) => boolean

/*
  Crunches table in the search: page query result is cached as an array of entities.
  Crunches table in the dashboard: page query result is cached as an infinite query result object having data and count.
  This fn gets the array of entities based on the page query result shape and returns if the page should be invalidated or not.
*/
export const shouldInvalidateCrunchesPage: ShouldInvalidateCrunchesPage = (
  page,
  entityUuid
) => {
  const pageData = Array.isArray(page)
    ? page
    : Array.isArray(page.data)
      ? page.data
      : []

  return pageData.find((entity: EntityWithUuid) => entity.uuid === entityUuid)
}
